import { createContext } from 'react';

import { User } from '@/models/user';

export const UserContext = createContext<{ user: User } | null>(null);

export const UserContextProvider = UserContext.Provider;
